import React, { useState } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

import { Checkbox } from 'shared/components';
import { GqlCustomNavigationItem, CustomNavigationItemType } from 'types/graphql';

import { ModalControllerProps } from './modal-controller';
import { BaseCustomNavigationModal, StyledInput } from './base-custom-navigation-modal';

export function AddLinkModal({ editingItem, onClose, onSave }: ModalControllerProps): JSX.Element {
  const [label, setLabel] = useState(editingItem?.label ?? '');
  const [url, setUrl] = useState(editingItem?.url ?? '');
  const [openInNewTab, setOpenInNewTab] = useState(editingItem?.openInNewTab ?? false);

  const isEditing = !!editingItem;
  const isValid = label.trim() !== '' && url.trim() !== '';

  const handleSave = (): void => {
    if (!isValid) {
      return;
    }

    const item: GqlCustomNavigationItem = {
      id: editingItem?.id ?? uuid(),
      items: editingItem?.items ?? [],
      label: label.trim(),
      openInNewTab,
      navigationType: CustomNavigationItemType.link,
      position: editingItem?.position ?? 0,
      url: url.trim(),
    };

    onSave(item);
    onClose();
  };

  return (
    <BaseCustomNavigationModal
      copy='Add a custom link to your navigation.'
      handleSave={handleSave}
      headerText='Link'
      inputLabel={label}
      isEditing={isEditing}
      isOpen
      isValid={isValid}
      onClose={onClose}
      setLabel={setLabel}
    >
      <StyledInput
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUrl(e.target.value)}
        placeholder='https://example.com or /category/flower?sortby=pricelowtohigh'
        value={url}
      />

      <CheckboxLabel>
        <Checkbox
          checked={openInNewTab}
          id='open-in-new-tab'
          label='Open in new tab'
          onChange={() => setOpenInNewTab(!openInNewTab)}
        />
        Open in new tab
      </CheckboxLabel>
    </BaseCustomNavigationModal>
  );
}

const CheckboxLabel = styled.label`
  cursor: pointer;
  display: flex;
  font-size: 12px;
  gap: 6px;
  margin-top: 10px;
  text-align: left;
`;
